function openCity(evt, cityName) {
  var i, flairglasstabcontent, flairglasstablinks;
  flairglasstabcontent = document.getElementsByClassName("flairglasstabcontent");
  for (i = 0; i < flairglasstabcontent.length; i++) {
    flairglasstabcontent[i].style.display = "none";
  }
  flairglasstablinks = document.getElementsByClassName("flairglasstablinks");
  for (i = 0; i < flairglasstablinks.length; i++) {
    flairglasstablinks[i].className = flairglasstablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}
$(document).ready(function () {
  var modalWap = $('.flairglass-modal-wapper');
  $(".modali--close").on('click',function() {
     modalWap.fadeOut();
  });
  $('.modali-gallery-block-a').on('click',function(e) {
      e.preventDefault();
      var srcid = $("#setfeatureimg");
      var svgloader = $(".modali-image-svgloader");
      svgloader.css('display','flex');
      srcid.css('display','none');
      var srci = $(this).attr('data-setfeatureimg');
      $('.modali-gallery-block').removeClass('active');
      $(this).parent('.modali-gallery-block').addClass('active');
      srcid.attr('src',srci);
      srcid.on('load', function() {
        svgloader.css('display','none');
        srcid.css('display','block');
      });
  });
  $('.modal-tigger-popuper').on('click',function (e) {
      $('.flairglass-modal-wapper').fadeIn('slow');
  })
});
